import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { GlobalComponent } from '../global-component';
import { Seasonal } from '../models/seasonal';
import { ApiResponse } from '../models/apiResponse';

const baseUrl = GlobalComponent.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class SeasonalApiService {
  constructor(
    private httpClient: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  getOngoingSeasonalEvents(): Observable<ApiResponse<Seasonal[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<Seasonal[]>>(
        baseUrl + '/Seasonal/GetOngoingSeasonalEvents'
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<Seasonal[]>);
  }

  getSeasonalCoupons(seoName: string): Observable<ApiResponse<Seasonal[]>> {
    if (isPlatformBrowser(this.platformId)) {
      return this.httpClient.get<ApiResponse<Seasonal[]>>(
        baseUrl + '/Seasonal/GetSeasonalCoupons?SeoName=' + seoName
      );
    }
    return of({
      data: [],
      success: false,
      message: 'Server-side rendering',
    } as unknown as ApiResponse<Seasonal[]>);
  }

  getSeasonalEvents() {
    return this.httpClient.get<ApiResponse<Seasonal[]>>(
      baseUrl + '/Seasonal/GetSeasonalEvents'
    );
  }
}
